<ws-modal-wrapper [headerLabel]="title"
                  (save)="save()"
                  [backdropClick]="hasBackdropClick"
                  (cancel)="cancel()">
    <div class="d-flex mt-4">
        @if (hasWarningIcon) {
            <div class="d-flex align-items-center me-5">
                <i class="fa fa-exclamation-triangle fa-4x warning-text"></i>
            </div>
        }
        @if (message) {
            <div>
                <p [innerHTML]="message"></p>
            </div>
        }
    </div>
    @if (messageList.length) {
        <div>
            @if (subtitle) {
                <p><strong>{{ subtitle }}</strong></p>
            }
            <ul [class.bulk-error-list]="isErrorState">
                @for (message of messageList; track $index) {
                    <li class="has-error" [innerHTML]="message"></li>
                }
            </ul>
        </div>
    }
    @if (footerMessage) {
        <p [innerHTML]="footerMessage"></p>
    }
    <ng-container modal-footer>
        <div class="d-flex w-100 justify-content-end">
                <div class="d-flex align-items-center">
                    <div>
                        <button type="button"
                                class="ace-btn btn-primary has-text me-1"
                                (click)="save()"
                                tabindex="0">
                            @if (hasYes) {Yes}
                            @if (hasOK) {OK}
                            @if (hasContinue) {Continue}
                        </button>
                    </div>
                    @if (hasNo) {
                        <div>
                            <button type="button"
                                    class="ace-btn btn-secondary has-text"
                                    (click)="no()"
                                    tabindex="0">
                                No
                            </button>
                        </div>
                    }
                    @if (hasCancel) {
                        <div>
                            <button type="button"
                                    class="ace-btn btn-secondary has-text"
                                    (click)="dismiss()"
                                    tabindex="0">
                                Cancel
                            </button>
                        </div>
                    }
                </div>
        </div>
    </ng-container>
</ws-modal-wrapper>
